"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFullEpisodeButton = exports.trackEndcardAutoplay = exports.trackEndcardPlayNow = exports.trackEndcardCancel = exports.setDataLayer = exports.trackShareLink = exports.trackRelatedView = exports.trackRelatedClick = exports.trackNextUpClick = void 0;
var EVENT_CATEGORY = 'player';
var link = function (data) {
    var TVA = window.TVA || [];
    TVA.push(['link', data]);
};
exports.trackNextUpClick = function () {
    link({
        event_name: 'player_click',
        event_category: EVENT_CATEGORY,
        event_label: 'up-next',
    });
};
exports.trackRelatedClick = function (_a) {
    var index = _a.index;
    link({
        event_name: 'player_click',
        event_category: EVENT_CATEGORY,
        event_label: 'suggested-content',
        event_value: index,
    });
};
exports.trackRelatedView = function (value) {
    link({
        event_name: 'player_view',
        event_category: EVENT_CATEGORY,
        event_label: 'suggested-content',
        event_value: value,
    });
};
exports.trackShareLink = function (target) {
    link({
        event_name: 'player_click-share-social',
        event_category: EVENT_CATEGORY,
        event_label: target,
        event_value: target,
    });
};
function setDataLayer(data) {
    var TVA = window.TVA || [];
    TVA.push(['setDataLayer', data]);
}
exports.setDataLayer = setDataLayer;
exports.trackEndcardCancel = function () {
    link({
        event_name: 'player_click',
        event_category: EVENT_CATEGORY,
        event_label: 'cancel-suggested-content',
    });
};
exports.trackEndcardPlayNow = function () {
    link({
        event_name: 'player_click',
        event_category: EVENT_CATEGORY,
        event_label: 'play-now-suggested-content',
    });
};
exports.trackEndcardAutoplay = function () {
    link({
        event_name: 'player_autoplay',
        event_category: EVENT_CATEGORY,
        event_label: 'suggested-content',
    });
};
exports.trackFullEpisodeButton = function (metadata) {
    link(__assign(__assign({}, metadata), { event_name: 'player_click', event_category: EVENT_CATEGORY, event_label: 'full_episode' }));
};
